import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InvalidMerchantAccount } from '../../shared';

@Component({
    selector: 'app-invalid-merchant-accounts',
    templateUrl: './invalid-merchant-accounts.component.html',
    styleUrls: ['./invalid-merchant-accounts.component.css']
})
export class InvalidMerchantAccountsComponent implements OnInit {

    merchantAccounts: InvalidMerchantAccount[];

    constructor(
        private readonly route: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.route.data.subscribe(({ merchantAccounts }: { merchantAccounts: InvalidMerchantAccount[] }) => {
            this.merchantAccounts = merchantAccounts;
        });
    }
}